import axios from "axios";
import config from "@/config/constants.js";

export default {
    namespaced: true,
    state: {
        status: "",
        selectedRole: null,
        location: null,
        result: null,
        error: null,
    },
    mutations: {
        loading(state) {
            state.status = "loading";
        },
        setRole(state, role) {
            state.selectedRole = role;
        },
        setLocation(state, location) {
            state.location = location;
        },
        setResult(state, result) {
            state.result = result;
            state.status = "";
        },
        setError(state, error) {
            state.error = error;
            state.status = "";
        },
        reset(state) {
            state.status = "";
            state.selectedRole = null;
            state.location = null;
            state.result = null;
            state.error = null;
        },
    },
    actions: {
        submitSignup({ commit }, data) {
            return new Promise((resolve, reject) => {
                commit("loading");
                const params = { ...data };
                // Normalize phone number
                if (params.phone_number) {
                    params.phone_number = params.phone_number.replace(/[\s-]/g, '');
                    params.phone_number = config.phone_extension + params.phone_number;
                }
                params.sms_consent_url = window.location.href;

                axios.post(config.api_url + 'signup/submit', params)
                    .then(response => {
                        if (response.data.code === "ERROR") {
                            commit("setError", response.data.message || "An error occurred.");
                            reject(response.data.message);
                        } else {
                            commit("setResult", response.data);
                            resolve(response.data);
                        }
                    })
                    .catch(err => {
                        const message = (err.response && err.response.data && err.response.data.message)
                            ? err.response.data.message
                            : "An error occurred. Please try again.";
                        commit("setError", message);
                        reject(message);
                    });
            });
        },

        selectTeam(_, { request_id, tenant_id }) {
            return new Promise((resolve, reject) => {
                axios.post(config.api_url + 'signup/select-team', { request_id, tenant_id })
                    .then(response => {
                        if (response.data.code === "ERROR") {
                            reject(response.data.message || "Could not join that team.");
                        } else {
                            resolve(response.data);
                        }
                    })
                    .catch(err => {
                        const message = (err.response && err.response.data && err.response.data.message)
                            ? err.response.data.message
                            : "Could not join that team. Please try again.";
                        reject(message);
                    });
            });
        },
    },
};
